import { render, staticRenderFns } from "./NameChangeGhostInput.vue?vue&type=template&id=11312b85&scoped=true&"
import script from "./NameChangeGhostInput.vue?vue&type=script&lang=js&"
export * from "./NameChangeGhostInput.vue?vue&type=script&lang=js&"
import style0 from "./NameChangeGhostInput.vue?vue&type=style&index=0&id=11312b85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11312b85",
  null
  
)

export default component.exports